import MaskedInput from 'react-text-mask';
import React from 'react';

const MASKED_CHARS = /[_]/g;

function AuthCodeInput({
  inputRef,
  onChange,
  ...rest
}) {
  return (
    <MaskedInput
      {...rest}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      onChange={(evt) => {
        return onChange(evt.target.value.replace(MASKED_CHARS, ''));
      }}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholder="______"
    />
  );
}

export default AuthCodeInput;
